var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTimelineView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2864_9162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67535 1H5.13151L5.1315 0H4.13151L4.13152 1H0.964844V4.82742H4.13151L4.13152 16H5.13151L5.1315 4.82742H9.67535V1ZM8.63151 2.04384H2.00869V3.78358H8.63151V2.04384ZM7.13151 6.9151H14.1138V8.65483H7.13151V6.9151ZM6.08767 9.69868V5.87126H12.1315V0H13.1315V5.87126H15.1576V9.69868H13.1315V10.6667H16.9909V14.4941H13.1315V16H12.1315V14.4941H8.79818V10.6667H12.1315V9.69868H6.08767ZM9.84202 11.7105H15.9471V13.4502H9.84202V11.7105Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2864_9162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.964844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimelineView);
export default __webpack_public_path__ + "static/media/icon--timeline-view.9941de02137e5d29301e574d7f2375ca.svg";
export { ForwardRef as ReactComponent };